// src/components/Shared/SectionTitle.js
import styled from 'styled-components';

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: ${props => props.light ? 'white' : '#151c48'};
  margin-bottom: 60px;
  font-weight: 800;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, ${props => props.light ? 'white, #5ab9d3' : '#151c48, #5ab9d3'});
    margin: 20px auto 0;
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 40px;
  }
`;

export default SectionTitle;